export const ChevronLeftIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M12.0181 15.1924C12.2063 15.3771 12.2063 15.6767 12.0181 15.8614C11.83 16.0462 11.5249 16.0462 11.3367 15.8614L3.5 8.16726L11.6774 0.138566C11.8656 -0.0461884 12.1707 -0.0461884 12.3589 0.138566C12.547 0.323321 12.547 0.62287 12.3589 0.807625L4.8629 8.16727L12.0181 15.1924Z"
                fill="currentColor"
            />
        </svg>
    );
};
